import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import { useAdminMyPageHeader } from 'bundles/composable-page-header-admin/contexts/AdminMyPageHeaderContext';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import NotificationsLegacyGridItem from 'bundles/composable-page-header/components/grid-items/NotificationsLegacyGridItem';
import CourseraHomeLogo from 'bundles/composable-page-header/components/grid-items/home-logo/CourseraHomeLogo';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import MobileMenuIconGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuIconGridItem';
import DefaultLoggedInMobileMenuConfig from 'bundles/composable-page-header/module-renderers/DefaultLoggedInMobileMenuConfig';

const LoggedInAdminMobileMainNav = () => {
  const {
    chosenEnterpriseProgram,
    enrolledDegreePrograms,
    enrolledEnterprisePrograms,
    chosenDegree,
    hasEnrolledPrograms,
    naptimeManagedThirdPartyOrganizations,
    hasCheatingIncidents,
    canViewEducatorAdminLink,
    isCourseraPlusLearner,
    courseraPlusSubscriptionCycle,
  } = useAdminMyPageHeader();

  // Home link on these pages are for admin only, so hardcoding /admin link here
  const LogoComponent = (
    <HomeLogoGridItemModule href="/admin" logos={[<CourseraHomeLogo key="1" />]} ariaLabel={undefined} />
  );

  return (
    <MainNavigationWrapper>
      <Grid item xs={8} sm={6} container alignItems="center">
        <MobileMenuIconGridItem
          menuConfig={
            <DefaultLoggedInMobileMenuConfig
              enrolledDegreePrograms={enrolledDegreePrograms}
              enrolledEnterprisePrograms={enrolledEnterprisePrograms}
              isCourseraPlusLearner={isCourseraPlusLearner}
              chosenDegree={chosenDegree}
              chosenEnterpriseProgram={chosenEnterpriseProgram}
              hasEnrolledPrograms={!!hasEnrolledPrograms}
              naptimeManagedThirdPartyOrganizations={naptimeManagedThirdPartyOrganizations}
              hasCheatingIncidents={hasCheatingIncidents}
              canViewEducatorAdminLink={canViewEducatorAdminLink}
              courseraPlusSubscriptionCycle={courseraPlusSubscriptionCycle}
            />
          }
          homeLogo={LogoComponent}
        />
        {LogoComponent}
      </Grid>
      <Grid item container xs={4} sm={6} alignItems="center" justifyContent="flex-end">
        <NotificationsLegacyGridItem />
      </Grid>
    </MainNavigationWrapper>
  );
};

export default LoggedInAdminMobileMainNav;
